<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="store"
      label-position="left"
      label-width="140px"
      style="width: 620px; margin-left:50px;"
    >
      <el-form-item label="名称" prop="store_name">
        <el-input v-model="store.store_name"/>
      </el-form-item>

      <v-image-upload
        v-model="store.cover"
        :is-edit="true"
        label="封面"
        prefix="store"
        ratio="1:1"
        propName="cover"
      />

      <el-form-item label="地址" prop="address">
        <el-input v-model="store.address" placeholder="请输入门店的地址"/>
      </el-form-item>

      <el-form-item label="腾讯地图坐标" prop="coordinate">
        <el-input v-model="store.coordinate" placeholder="请输入门店的腾讯地图坐标"/>
        <a class="primary-color" href="https://lbs.qq.com/getPoint/" target="_blank">点此搜索坐标</a>
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input v-model="store.phone" placeholder="请输入门店的手机号"/>
      </el-form-item>

      <el-form-item label="微信号" prop="we_chat_number">
        <el-input v-model="store.we_chat_number" placeholder="请输入门店的微信号"/>
      </el-form-item>

      <v-image-upload
        v-model="store.we_chat_cover"
        :is-edit="true"
        label="微信二维码"
        prefix="store"
        ratio="1:1"
        propName="we_chat_cover"
        ref="weChatCover"
      />

      <el-form-item label="营业时间" prop="business_hours">
        <el-input v-model="store.business_hours"/>
      </el-form-item>

      <el-form-item label="课表图片高亮颜色" prop="schedule_color">
        <el-input
          v-model="store.schedule_color"
          minlength="5"
          maxlength="11"
          placeholder="请输入格式为 R,G,B 的课表图片高亮颜色，例如黑色：0,0,0"
        >
        </el-input>
      </el-form-item>

      <el-form-item label="每月成本">
        <el-input
          v-model="store.cost"
          min="0"
          type="number"
        >
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="每月房租">
        <el-input
          v-model="store.rent"
          min="0"
          type="number"
        >
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="企业微信标签 ID">
        <el-input v-model="store.we_chat_tag_id" min="0" type="number"/>
      </el-form-item>

      <el-form-item label="收入分成比例">
        <el-input
          v-model="store.revenue_sharing"
          min="0"
          max="100"
          type="number"
          @input="handleRevenueSharingChange"
        >
          <template v-slot:append>%</template>
        </el-input>
      </el-form-item>

      <el-form-item label="是否启用阶梯式分成">
        <el-switch v-model="store.is_ladder_commission" :active-value="1" :inactive-value="0"/>
        <el-alert
          title="总部对门店的默认分成方式为：总收入 × 分成比例，最多不超过净利润（总收入 - 总支出）的 40 %；开启后则根据总收入大小按阶梯式分成，最低分成为 1000 元，最多不超过毛利润（总收入 - 房租 - 老师工资 - 员工工资）的 20 %"
          type="info"
          show-icon
          :closable="false"
          class="alert-box"
        />
        <el-alert
          title="阶梯式分成比例：
收入 0 - 10 万，4 %；
收入 10 - 15 万，5 %；
收入 15 - 20 万，6 %；
收入 20 - 30 万，7 %；
收入 30 万以上，8 %"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="前台提成比例">
        <el-input
          v-model="store.receptionist_percentage"
          min="0"
          max="100"
          type="number"
          @input="handleReceptionistPercentage"
        >
          <template v-slot:append>%</template>
        </el-input>
      </el-form-item>

      <el-form-item label="未完成任务底薪比例">
        <el-input
          v-model="store.unfinished_rate"
          min="0"
          max="100"
          type="number"
          @input="handleUnfinishedRate"
        >
          <template v-slot:append>%</template>
        </el-input>
      </el-form-item>

      <el-form-item label="业绩任务">
        <el-input
          v-model="store.task_income"
          min="0"
          type="number"
        >
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="是否开启业绩任务">
        <el-switch v-model="store.task_enabled" :active-value="1" :inactive-value="0"/>
      </el-form-item>
      <el-form-item label="课卡是否全国通用">
        <el-switch v-model="store.is_generic" :active-value="1" :inactive-value="0"/>
      </el-form-item>
      <el-form-item label="是否在小程序显示">
        <el-switch v-model="store.is_private" :active-value="0" :inactive-value="1"/>
      </el-form-item>
      <el-form-item label="小程序课表默认分类">
        <el-radio
            v-for="courseTab in courseTabs"
            :key="`courseTab${courseTab}`"
            v-model="store.course_tab"
            :label="courseTab"
        >
          {{ courseTab }}
        </el-radio>
      </el-form-item>

      <el-form-item label="小程序客服号">
        <v-select-customer
          v-model="store.open_kfid"
          :clearable="true"
          placeholder="请选择小程序客服号"
        />
      </el-form-item>

      <el-form-item label="小程序客服号链接">
        {{ store.customer_url }}
        <el-alert
          title="选择客服号并提交保存后，由系统自动获取"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>


      <el-form-item label="是否启用阶梯式薪资">
        <el-switch v-model="store.is_ladder_salary" :active-value="1" :inactive-value="0" />
      </el-form-item>

      <div class="submit-button-box">
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.storeList.back">取消</el-button>
      </div>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from "@/router/config";
  import { courseTabs } from '@/enums/courseTabs';
  import { show, update } from '@/api/store';
  import { toCent, toYuan } from "@/filters";

  export default {
    name: RouteConfig.storeEdit.name,
    data: () => ({
      RouteConfig,
      courseTabs,
      isSaving: false,
      store: {
        store_name: '',
        address: '',
        coordinate: '',
        phone: '',
        we_chat_number: '',
        we_chat_cover: '',
        business_hours: '11:00-21:00',
        schedule_color: '0,0,0',
        cost: '',
        rent: '',
        revenue_sharing: '',
        is_ladder_commission: 0,
        receptionist_percentage: '',
        unfinished_rate: '',
        cover: '',
        we_chat_tag_id: '',
        task_income: '',
        is_generic: 0,
        task_enabled: 0,
        is_private: 0,
        is_ladder_salary: 0,
        course_tab: '',
        open_kfid: '',
        customer_url: '',
      },
      rules: {
        store_name: [{ required: true, message: '请输入门店名称', trigger: 'change' }],
        cover: [{ required: true, message: '请上传门店封面', trigger: 'change' }],
        address: [{ required: true, message: '请输入门店地址', trigger: 'change' }],
        coordinate: [{ required: true, message: '请输入门店的腾讯地图坐标', trigger: 'change' }],
        phone: [{ required: true, message: '请输入门店的手机号', trigger: 'change' }],
        we_chat_number: [{ required: true, message: '请输入门店的微信号', trigger: 'change' }],
        we_chat_cover: [{ required: true, message: '请上传门店微信二维码', trigger: 'change' }],
        business_hours: [{required: true, message: '请输入门店的营业时间', trigger: 'change'}],
        schedule_color: [{
          required: true,
          message: '请输入格式为 R,G,B 的课表图片高亮颜色，例如黑色：0,0,0',
          trigger: 'change'
        }],
        course_tab: [{ required: true, message: '请选择小程序课表默认分类', trigger: 'change' }],
      },
    }),
    computed: {
      id() {
        return +this.$route.params.id || 0;
      },
    },
    methods: {
      handleDelete(index, rows) {
        rows.splice(index, 1);
      },
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        data.cost = toYuan(data.cost);
        data.rent = toYuan(data.rent);
        data.task_income = toYuan(data.task_income);
        data.revenue_sharing = toYuan(data.revenue_sharing);

        const { store } = this;
        const updateData = {};
        Object.keys(data).forEach(key => {
          if (key in store) updateData[key] = data[key];
        });
        Object.assign(store, updateData);
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          this.isSaving = true;

          const postData = { ...this.store };
          postData.cost = toCent(postData.cost);
          postData.rent = toCent(postData.rent);
          postData.task_income = toCent(postData.task_income);
          postData.revenue_sharing = toCent(postData.revenue_sharing);

          const [latitude_gcj, longitude_gcj] = postData.coordinate.split(',');
          postData.latitude_gcj = latitude_gcj;
          postData.longitude_gcj = longitude_gcj;

          const {isError} = await update(this.id, postData);
          this.isSaving = false;
          if (isError) return;

          RouteConfig.storeList.back();
        });
      },
      handleRevenueSharingChange(value) {
        if (value < 0) {
          this.store.revenue_sharing = 0;
        } else if (value > 100) {
          this.store.revenue_sharing = 100;
        }
      },
      handleReceptionistPercentage(value) {
        if (value < 0) {
          this.store.receptionist_percentage = 0;
        } else if (value > 100) {
          this.store.receptionist_percentage = 100;
        }
      },
      handleUnfinishedRate(value) {
        if (value < 0) {
          this.store.unfinished_rate = 0;
        } else if (value > 100) {
          this.store.unfinished_rate = 100;
        }
      },
    },
    beforeMount() {
      this.show();
    },
  };
</script>

<style src="./add.css" lang="css" scoped/>
